import { render, staticRenderFns } from "./ColorGradient.vue?vue&type=template&id=2644b62e&scoped=true&"
import script from "./ColorGradient.vue?vue&type=script&lang=js&"
export * from "./ColorGradient.vue?vue&type=script&lang=js&"
import style0 from "./ColorGradient.vue?vue&type=style&index=0&id=2644b62e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2644b62e",
  null
  
)

export default component.exports